import React,{useState,useEffect} from 'react'
import { getStudentUser, getTeacherUser, loginUser } from '../../api/authService'
import useApi from '../../api/useApi'
import {
    TextField,
    Button,
    Divider,
    IconButton,
    Stack,
  } from "@mui/material";
  import {
    Visibility,
    VisibilityOff,
    PersonAdd,
    Settings,
  } from "@mui/icons-material";
import { Link, useNavigate,useLocation } from 'react-router-dom'
import { toast } from 'react-toastify';
// import {useAuth} from '../hooks/useAuth';
// import {useOnlineStatus,useRealOnlineStatus} from '../../hooks/useOnlineStatus'
import { Alert, Box, Typography } from "@mui/material";
// import { Offline, Online,Detector } from "react-detect-offline";
import { useAuth } from '../../hooks/useAuth'
import { StaffGetDetail } from '../../api/orgService';


function SignIn() {
    const navigate = useNavigate()
    const { login } = useAuth();
    const location = useLocation()
    // const isOnline = useOnlineStatus();

    const redirect = location?.state?.from?.pathname || "/staff/"; 

    const [form,setForm] = useState({})
    const { request: loginuser, data, error, isLoading } = useApi(loginUser);
    const { request:getStaff,data:getStaffData,error:getStaffError,isLoading:getStaffIsLoading}=useApi(StaffGetDetail)
    // const { request: getStduser, data:stdData, error:stdError } = useApi(getStudentUser);
    // const { request: getTchuser, data:tchData, error:tchError } = useApi(getTeacherUser);
    const onchange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        }; 
    const loginFormInvalid =
        !form?.email?.length || !form?.password || !form.password.length;
    const [viewPass,setViewPass] = useState("password")
    const handleClick = (e)=>{
        e.preventDefault()
        
        // if(!form?.username){
        //     form.username = ""
        // }
        // if(!form?.middle_name){
        //     form.middle_name = ""
        // }
        // console.log(form)
        // delete form?.confirm_password
        loginuser(form)
        // console.log(isLoading)
        // console.log(data)
        // console.log(error)
        
    }
    
    // useEffect(() => {
    //     if(error){
    //         toast.error(`${JSON.stringify(error?.response?.data,null,2)}`,{position: "top-center"});
    //         // setForm({})
    //     }
    // },[error])

    // useEffect(() => {
    //     if(stdError){
    //         toast.error(`${JSON.stringify(stdError?.response?.data,null,2)}`,{position: "top-center"});
    //         // setForm({})
    //     }
    // },[stdError])

    useEffect(() => {
        if(getStaffError){
            toast.error(`${JSON.stringify(getStaffError?.response?.data,null,2)}`,{position: "top-center"});
            // setForm({})
        }
    },[getStaffError])

    useEffect(() => {
        if(data){
            console.log(data)
            toast.success(`${JSON.stringify(data?.statusText)}, login successful`,{position: "top-center"});
            if(data?.status ===200){
                const { tokens, ...userData } = data?.data
                getStaff(userData?.user?.id)
                // if(userData?.is_teacher){
                //     getTchuser({user_id:userData?.id})
                // }else if(userData?.is_student){
                //     getStduser({user_id:userData?.id})
                // }

                
            }
        
        } 
      }, [data,navigate]);

    useEffect(()=>{

    if(getStaffData?.status===200){
        const { tokens, ...userData } = data?.data

        login({userData: userData, jwtToken: tokens,user:getStaffData?.data})
        let redirect_url = location?.state?.from?.pathname || "/staff/"; 
            setTimeout(()=>{
                navigate(redirect_url,{ replace: true })
                },2000)
                setForm({})
        }
      },[getStaffData,navigate])


    // useEffect(()=>{

    //  if(tchData?.status===200){
    //     const { tokens, ...userData } = data?.data

    //     login({userData: userData, jwtToken: tokens,teacher:tchData})
    //     let redirect_url_b = location?.state?.from?.pathname || "/t"; 
    //         setTimeout(()=>{
    //             navigate(redirect_url_b,{ replace: true })
    //             },2000)
    //             setForm({})

    //    }
    //   },[tchData,navigate])

    const setView = ()=>(setViewPass("text"))
    const setClose = ()=>(setViewPass("password"))
    return (
        <Box className="Form-Signup" sx={{ display: "flex", flexDirection: "row" }}>
        <Box className="Form-A" sx={{ flex: 1 }}></Box>
  
        <Box className="Form-B" sx={{ flex: 2, textAlign: "center", p: 4 }}>
          <Typography variant="h5" gutterBottom>
            Fountain Africa Trust SignIn
          </Typography>
  
          {/* Replacing IconGroup */}
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={1}
            sx={{ mb: 2 }}
          >
            <PersonAdd sx={{ fontSize: 40, color: "teal" }} />
            <Settings
              sx={{ fontSize: 25, color: "grey" }}
              className="spin"
            />
          </Stack>
  
          <Typography variant="h6" gutterBottom>
            Staff Login/SignIn
          </Typography>
  
          <Box sx={{ p: 2 }}>
            {/* <Detector
              render={({ online }) => (
                <Alert severity={online ? "success" : "warning"} sx={{ mt: 0 }}>
                  {online ? (
                    <span>
                      You are currently <strong>online</strong>. Please proceed to
                      login.
                    </span>
                  ) : (
                    <span>
                      You are currently <strong>offline</strong>. Please connect to
                      the internet to access our services.
                      <br />
                      Check Wi-Fi or Ethernet connection.
                    </span>
                  )}
                </Alert>
              )}
            /> */}
          </Box>
  
          {/* MUI Form */}
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": { m: 1, width: "90%" },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            noValidate
            autoComplete="off"
          >
            <TextField
              required
              label="Email"
              type="email"
              name="email"
              placeholder="Enter your @fountainafrica.org email"
              value={form?.email || ""}
              onChange={onchange}
              variant="outlined"
            />
  
            {/* Password Field */}
            <Box sx={{ position: "relative", width: "100%", m: 1 }}>
              <TextField
                required
                label="Password"
                type={viewPass === "password" ? "password" : "text"}
                name="password"
                placeholder="Enter your password"
                value={form?.password || ""}
                onChange={onchange}
                variant="outlined"
                fullWidth
                sx={{
                    mr:2,
                }}
              />
              <IconButton
                onClick={viewPass === "password" ? setView : setClose}
                sx={{ position: "absolute", right: 30, top: 15 }}
              >
                {viewPass === "password" ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </Box>
  
            {/* Login Button */}
            <Button
              fullWidth
              variant="contained"
              color="primary"
              disabled={loginFormInvalid}
              onClick={handleClick}
              sx={{ mt: 2,
                width: "90%"
               }} 
            >
              {isLoading ? "Loading..." : "Log In"}
            </Button>
  
            <Divider sx={{ my: 2 }}>or</Divider>
  
            <Typography variant="body2" gutterBottom>
              Don’t have an account? <Link to="/signin">Contact Admin</Link>
            </Typography>
            <Typography variant="body2">
              Forgot your password? <Link to="/password_reset">Reset</Link>
            </Typography>
          </Box>
        </Box>
  
        <Box className="Form-C" sx={{ flex: 1 }}></Box>
      </Box>
  )
}


export default SignIn